import type { ExtractPropTypes, PropType } from 'vue'
import { ComponentPublicInstance } from 'vue'
import type { ColumnItem } from './index'
export const cosTableProps = () => ({
  columns: {
    type: Array as PropType<ColumnItem[]>,
    default: () => []
  },
  dataSource: {
    type: Array as PropType<{ [key: string]: any }[]>
  },
  search: {
    type: Object,
    default: () => {
      return {}
    }
  },
  searchSpan: {
    type: Number,
    default: 8
  },
  rowSelection: {
    type: Object
  },
  pagination: {
    type: Boolean,
    default: true
  },
  loading: {
    type: Boolean
  },
  needPage: {
    type: Boolean,
    default: true
  },
  dynamicColumnSetting: {
    type: Boolean,
    default: true
  }
})
export type FormExpose = {
  fetch: () => void
  search: () => void
}

export type CosTableProps = Partial<ExtractPropTypes<ReturnType<typeof cosTableProps>>>
export type CosTableInstance = ComponentPublicInstance<CosTableProps, FormExpose>
export default cosTableProps
